import { EnvironmentTargetInterface } from '@environments/assets/environment-target.interface';

export const proxyApiTargets: EnvironmentTargetInterface = {
  production: {
    baseUrl: 'https://api.proxy.fagforbundet.no',
  },
  staging: {
    baseUrl: 'https://api.proxy.fagforbundet.dev',
  },
};
